import ScrollReveal from "@/components/base/ScrollReveal";
import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative bg-primary py-20 md:py-28 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-white rounded-full blur-3xl" />
      </div>

      {/* Animated ring decorations */}
      <div className="absolute top-10 left-10 w-32 h-32 border border-white/10 rounded-full hidden lg:block" />
      <div className="absolute bottom-10 right-10 w-48 h-48 border border-white/10 rounded-full hidden lg:block" />
      <div className="absolute top-1/2 right-1/4 w-20 h-20 border border-white/5 rounded-full hidden lg:block" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <div className="max-w-3xl mx-auto">
          <ScrollReveal>
            <h2 className="font-serif text-[32px] md:text-[44px] lg:text-[48px] font-semibold text-white leading-tight mb-5">
              Ready to Move AI Forward{" "}
              <span className="italic">With Confidence?</span>
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="font-sans text-[17px] md:text-[19px] text-white/80 mb-10">
              Whether you are building AI governance from the ground up, refining strategy, or preparing your workforce, a single conversation can clarify your next steps.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={300}>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
              <Link
                to="/contact"
                className="font-sans text-[16px] font-medium text-primary bg-white hover:bg-text-headline px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 inline-block"
              >
                Schedule a 30-Minute Consultation
              </Link>
              <a
                href="mailto:smurray@vantagesightai.com"
                className="font-sans text-[16px] font-medium text-white border-2 border-white hover:bg-white hover:text-primary px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap hover:scale-105"
              >
                Send an Email
              </a>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={450}>
            <p className="font-sans text-[15px] text-white/60">
              No pressure. Just a conversation about your organization&apos;s AI needs.
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}